module.exports = __webpack_public_path__ + "img/info-category.107f075d.svg";